import React from "react";
import { Box, Paper, Typography, useTheme, List, ListItem } from "@mui/material";

const AboutWithSubsCard = ({ title, list }) => {
  const theme = useTheme();
  const groups = list && typeof list === "object" ? list : {};
  if (!Object.keys(groups).length) return null;

  return (
    <Paper
      sx={{
        p: "1.25rem 1.5rem",
        mb: "1rem",
        backgroundColor: theme.palette.background.alt,
      }}
    >
      <Typography
        variant="h5"
        fontWeight={700}
        color={theme.palette.secondary.main}
        sx={{ mb: "0.5rem" }}
      >
        {title}
      </Typography>
      {Object.keys(groups).map((key, index) => (
        <Box key={`${title}:${key}:${index}`} sx={{ mb: "0.75rem" }}>
          <Typography
            variant="body1"
            fontWeight={600}
            color={theme.palette.text.primary}
            sx={{ mb: "0.15rem" }}
          >
            {key}
          </Typography>
          <List sx={{ py: 0 }}>
            {groups[key].map((item) => (
              <ListItem
                key={`${title}:${key}:${index}:${item}`}
                disablePadding
                sx={{ py: "0.15rem" }}
              >
                <Box
                  component="span"
                  sx={{
                    width: "5px",
                    height: "5px",
                    borderRadius: "50%",
                    backgroundColor: theme.palette.text.secondary,
                    mr: "0.65rem",
                    flexShrink: 0,
                  }}
                />
                <Typography variant="body1" color={theme.palette.text.secondary}>
                  {item}
                </Typography>
              </ListItem>
            ))}
          </List>
        </Box>
      ))}
    </Paper>
  );
};

export default AboutWithSubsCard;
